<template>
  <form @submit.prevent="submit">
    <base-modal small :target="id" title="Add Bank Account">
      <base-field label="Country" mandatory>
        <base-select placeholder="country" source="countries" v-model="payload.country" />
      </base-field>
      <base-field label="Bank Name" mandatory>
        <base-input placeholder="bank name" v-model="payload.bank" />
      </base-field>
      <base-field label="Account Number" mandatory>
        <base-input placeholder="account number" type="number" v-model="payload.accountNumber" />
      </base-field>
      <base-field label="Sort Code" mandatory>
        <base-input placeholder="sort code" type="number" v-model="payload.sortCode" />
      </base-field>
      <base-field class="mb-0" label="IBAN" mandatory>
        <base-input placeholder="iban" v-model="payload.iban" />
      </base-field>
      <div>
        <small>
          You can find your IBAN (International Bank Account Number) on your bank statement.
        </small>
      </div>
      <template slot="footer">
        <base-button :loading="isCreatePending" primary submit>
          Save
        </base-button>
      </template>
    </base-modal>
  </form>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'BankAccountCreate',

  data: () => ({
    payload: {}
  }),

  created () {
    this.payload = this.$_.cloneDeep(this.schema)
  },

  computed: {
    id () {
      return 'addBankAccountModal'
    },

    ...mapGetters({
      schema: 'core/bank-accounts/schema'
    }),

    ...mapState({
      bank: store => store.core.bankAccounts.entity,
      errorOnCreate: store => store.core.bankAccounts.errorOnCreate,
      isCreatePending: store => store.core.bankAccounts.isCreatePending
    })
  },

  methods: {
    submit () {
      this.$store.dispatch('core/bank-accounts/create', this.payload)
        .then(() => {
          this.$modal.close(`#${this.id}`)
          this.$flash.success('Bank account successfully saved.')
          this.$emit('saved', this.bank)
        })
        .catch(() => {
          this.$flash.failure(this.errorOnCreate)
        })
    }
  }
}
</script>
